module.exports = __webpack_public_path__ + "static/img/2.bf535552.png";